import React from 'react';

export const Help = () => {
    return (
        <svg
            viewBox="0 0 18 18"
            id="icn-help-12"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
        >
            <path
                d="M9 16A7 7 0 1 1 9 2a7 7 0 0 1 0 14zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm.75-4c0-.316.13-.495.654-.928l.074-.062c.891-.737 1.272-1.274 1.272-2.26C11.75 5.033 10.608 4 9 4a2.75 2.75 0 0 0-2.75 2.75.75.75 0 0 0 1.5 0c0-.69.56-1.25 1.25-1.25.812 0 1.25.396 1.25 1.25 0 .414-.152.628-.728 1.104l-.074.062C8.606 8.612 8.25 9.102 8.25 10a.75.75 0 1 0 1.5 0z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};
